import { css, SerializedStyles } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { withConfig } from 'src/withConfig';



interface RaceSummaryPropsType {

    variant: DefaultComponentVariantType | null;

}



const setRaceSummaryCaption = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            border-radius: ${theme.star.radius.small};

            gap: ${theme.star.gap.small};

            padding-right: ${theme.star.padding.small};

        `;

    }

    return css`

        border: 1px solid ${theme.star.raceSummary.borderColor};

    `;

};



/* Table caption and cells */

export const RaceSummaryCaption = withConfig(theme => styled('div', { label: 'RaceSummaryCaption' })<RaceSummaryPropsType>`

    ${({ variant }): SerializedStyles => setRaceSummaryCaption(variant, theme)};

    background: ${theme.star.raceSummary.bgColorSecondary};

    color: ${theme.star.raceSummary.txtColorTertiary};

    display: flex;

    flex-flow: row nowrap;

    font-size: ${theme.star.fontSize.xSmall};

    justify-content: space-between;

    line-height: 1.4;

`);



const setRaceCell = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => css`

    align-items: center;

    border-style: solid;

    border-color: ${theme.star.raceSummary.borderColor};

    border-width: ${variant === DefaultComponentVariantType.SECONDARY ? '0' : '0 1px'};

    display: flex;

    font-size: ${theme.star.fontSize.xSmall};

    justify-content: center;

`;



export const RunnerCaption = withConfig(theme => styled('div', { label: 'RunnerCaption' })<RaceSummaryPropsType>`

    ${({ variant }): SerializedStyles => setRaceCell(variant, theme)};

    flex: 1 1 0%;

    font-weight: ${theme.star.fontWeight.xMedium};

    padding: 1px 8px;

    justify-content: flex-start;

`);



interface PropsType {

    isRaceInProgress?: boolean;

    variant: DefaultComponentVariantType | null;

}



export const SelectionCaption = withConfig(theme => styled('span', { label: 'SelectionCaption' })<PropsType>`

    ${({ variant }): SerializedStyles => setRaceCell(variant, theme)};

    flex: 0 0 48px;

    font-weight: ${theme.star.fontWeight.xMedium};

    padding: 1px 4px;

    text-align: center;

    margin-left: -1px;

    &:last-of-type {

        border-right: 0;

    }

    @media ${theme.star.mediaQuery.tablet} {

        flex: 0 0 64px;

    }

`);



interface RaceSummaryRowPropsType {

    isNonRunner?: boolean;

    variant: DefaultComponentVariantType | null;

}



const setRaceSummaryRow = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            gap: ${theme.star.gap.small};

            padding: ${theme.star.padding.small};

            border-radius: ${theme.star.radius.medium};

        `;

    }

    return css`

        border-bottom: 1px solid ${theme.star.raceSummary.borderColor};

        @media ${theme.star.mediaQuery.tablet} {

            border-left: 1px solid  ${theme.star.raceSummary.borderColor};

        }

    `;

};



export const RaceSummaryRow = withConfig(theme => styled('li', { label: 'RaceSummaryRow' })<RaceSummaryRowPropsType>`

    ${({ variant }): SerializedStyles=> setRaceSummaryRow(variant, theme)};

    background-color: ${theme.star.raceSummary.bgColor};

    color: ${theme.star.raceSummary.txtColor};

    display: flex;

    flex-flow: row nowrap;

    min-height: 72px;

    justify-content: space-between;

    opacity: ${({ isNonRunner }): number => isNonRunner === true ? 0.4 : 1};

    position: relative;

    @media ${theme.star.mediaQuery.tablet} {

        min-height: 64px;

    }

`);

